const panaramViewerGlobalId = "360Viewer";
export default panaramViewerGlobalId;
